import React, { useContext, useState } from "react";
import QuestionAns from "./QuestionAns";
import { useScreenTransition } from "../../Hooks/useScreenTransition";
import { DataContext } from "../../Context/DataContext";
import { AuthContext } from "../../Context/AuthContext";
import { HashLink } from "react-router-hash-link";

const FaqSection = (windowSize) => {
  const { transitionTo } = useScreenTransition();

  const { signedIn } = useContext(AuthContext);
  const { userData, order, setOrder } = useContext(DataContext);

  const [activeCategory, setActiveCategory] = useState("generalQuestions");

  const questionsCatagories = [
    { name: "General Questions", value: "generalQuestions" },
    { name: "Certified Translations", value: "certifiedTranslations" },
    { name: "Standard Translations", value: "standardTranslations" },
    { name: "About eVerbary", value: "abouteVerbary" },
    { name: "Other Questions", value: "otherQuestions" },
  ];

  const GotoPage = (id, e) => {
    e.preventDefault();
    transitionTo("/", e);

    setTimeout(() => {
      const element = document.getElementById(id);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }, 500);
  };

  const gotoOrder = () => {
    if (!signedIn) {
      transitionTo("/order/type");
      return;
    }
    if (signedIn && (userData.accountType === "personal" || !userData.teamId)) {
      transitionTo("/order/documents");
      localStorage.setItem(
        "order",
        JSON.stringify({ ...order, type: "personal" })
      );
      setOrder((q) => ({ ...q, type: "personal" }));
    } else if (
      signedIn &&
      (userData.accountType === "business" || userData.teamId)
    ) {
      transitionTo("/order/documents");
      localStorage.setItem(
        "order",
        JSON.stringify({ ...order, type: "business" })
      );
      setOrder((q) => ({ ...q, type: "business" }));
    }

    // Fixing incorrect logical conditions
  };

  const questions = {
    generalQuestions: [
      {
        question: "Who will translate my documents?",
        answer:
          "  We only use 100% human translation carried out by professional translators. Our translators are based all over the world and typically have a minimum of 5 years of experience as professional translators. Many carry a variety of accreditations and certifications, but this varies per translator as there is no standard worldwide accreditation or certification for translators",
      },
      {
        question: "How long does translation take?",
        answer:
          "Turnaround time depends on many factors including the word count, language pair, current demand, translator availability and complexity of the source document to name a few. In general, 1-3 page documents (up to 750 words) are delivered digitally in 24 hours or less. Expedited turnaround is available to reduce the turnaround time by approximately 50%. We will show an estimated turnaround time in the order page before you place it.",
      },
      {
        question: "What languages do you translate?",
        answer: (
          <p>
            Please review the full list of our &nbsp;
            <span
              className="underline cursor-pointer"
              onClick={(e) => transitionTo("/languages", e)}
            >
              supported languages
            </span>
            . If you require a language we do not have listed please &nbsp;
            <span
            className="underline cursor-pointer"
            ><HashLink smooth to="/#support">contact us</HashLink></span>,
            we can likely still assist you.
          </p>
        ),
      },
      {
        question: "What documents do you translate?",
        answer: ( <p>
          We can translate nearly any legible document in almost any format. If you are unsure if your document is translatable, please &nbsp;
          <span
            className="underline cursor-pointer"
          >
             <HashLink smooth to="/#support">contact our support team.</HashLink>
          </span>
        </p>)
      },
      {
        question: "Will your translation be accepted?",
        answer: (
          <p>
            Our translations are generally accepted by governments, courts,
            universities, etc. worldwide, but it is your responsibility to
            ensure our translation will meet the specific requirements of the
            receiving office. If you aren't sure, &nbsp;
            <span
              className="underline cursor-pointer"
            >
              <HashLink smooth to="/#support">contact us</HashLink>
            </span>
            &nbsp; with a list of their requirements and we can review with you.
            <br />
            <br />
            We regularly perform translations for U.S. Citizenship and
            Immigration Services (USCIS) and are intimately familiar with their
            requirements. Therefore we guarantee acceptance of our certified
            translations by USCIS.
          </p>
        ),
      },
      {
        question: "Can I supply notes to my translator?",
        answer:
          "Yes, during checkout you will find a notes field where you can enter any notes you'd like our staff or your translator to have. Proper spelling of names and places is requested as not all are directly translatable.",
      },
      {
        question: "How do you keep my information secure?",
        answer: (
          <p>
            Your information, including files, is transmitted through a secure
            channel with SSL/TLS encryption, which is the current standard for
            encryption on the web. Also:
            <br />
            <br />
            <ul className="list-disc pl-12 flex flex-col gap-3">
              <li>
                We do not store your credit card information on our servers. It
                is only handled and stored in a PCI-compliant environment by our
                processing partner PayPal.
              </li>

              <li>
                We will never share your files or personal information with
                anyone outside of eVerbary.
              </li>

              <li>
                Files are only available to essential staff with signed NDAs.
              </li>

              <li>
                Files are encrypted during transfer and while being stored with
                the Advanced Encryption Standard 256 bits (AES-256).
              </li>
            </ul>
          </p>
        ),
      },
      {
        question: "What are your payment terms and methods?",
        answer: (
          <p>
            We accept credit cards, debit cards, wire transfers, checks and
            PayPal. Should you need any assistance for processing the payment,
            please contact us at support@everbary.com
            <br />
            <br />
            Payment is requested in advance. You can see our Refund Policy here.
          </p>
        ),
      },
    ],
    certifiedTranslations: [
      {
        question: "What is a certified translation?",
        answer:
          "A word-for-word human translation of documents delivered on eVerbary letterhead including a signed and stamped Certificate of Translation Accuracy for official use as required by U.S. Immigration (USCIS), universities, courts, and many local, state, and federal governments.",
      },
      {
        question: "What will you deliver to me?",
        answer: (
          <p>
            Certified translations are delivered as a non-editable PDF file and
            include a signed and stamped English language Certificate of
            Translation Accuracy, which attests to the thoroughness and accuracy
            of the translation and the qualifications of the translator. In
            addition, our certified translations:
            <br />
            <br />
            <ul className="list-disc pl-12 flex flex-col gap-3">
              <li>
                Are on company letterhead containing our ATA member number,
                phone number, and address.
              </li>
              <li>Include the order number and page number on each page.</li>
              <li>
                Are formatted similar to, but not exactly like, the source
                document.
              </li>
              <li>
                Are word-for-word translations of the source, which means some
                phrases might not be ideal, but we cannot interpret the meaning
                of a phrase, only provide an exact translation per certified
                translation standards.
              </li>
              <li>
                Do not include a copy of your source files in the same PDF
                unless specifically requested.
              </li>
            </ul>
            <br />
            If you order a physical copy we will ship you an unfolded copy of
            the translation with wet ink signatures in a cardboard USPS envelope
            printed on 24 lb. paper via a color laser printer. We do not print
            and ship a copy of your source documents as you will pair our
            translation with the originals already in your possession.
          </p>
        ),
      },
      {
        question: "Do you offer expedited turnaround?",
        answer:
          "Expedited turnaround is available for an additional fee and will reduce turnaround time by approximately 50%. Expedited orders are flagged as high-priority, moved to the front of the queue, and extended hours are worked to ensure the quickest turnaround possible.",
      },
      {
        question: "Do you offer notarization?",
        answer:
          "We offer notarization as an option on all certified translations for an additional fee. Notarization includes a signature from either a representative of our company or a translator and a Notary Public along with a rubber ink stamp from the Notary with their commission number and commission expiration date. The notarization is valid in all 50 states.",
      },
      {
        question: "Can you supply an apostille for my notarized translation?",
        answer:
          "We do not supply an apostille for your notarized translation, but you can obtain one from the Secretary of State. We kindly ask you to let us know in advance if you will need an apostille.",
      },
      {
        question: "Can you send me a physical copy?",
        answer: (
          <p>
            We offer USPS Priority and Express Mail services with tracking.
            Pricing and transit times vary by destination and are listed during
            <span
              className="underline cursor-pointer"
              onClick={() => gotoOrder()}
            >
              {" "}
              checkout
            </span>{" "}
            or you may{" "}
            <span
              className="underline cursor-pointer"
              onClick={(e) => transitionTo("/quote/details", e)}
            >
              {" "}
              request a quote{" "}
            </span>
            .
            <br />
            <br />
            If you order a physical copy we will ship you an unfolded copy of
            the translation with wet ink signatures in a cardboard USPS envelope
            printed on 24 lb. paper via a color laser printer. We do not print
            and ship a copy of your source documents as you will pair our
            translation with the originals already in your possession.
            <br />
            <br />
            We will notify you via email when your translation is ready for
            review. We request your approval prior to shipping and will hold
            your shipment for up to one week waiting for your response. Once
            approved and/or shipped we will only be able to apply revisions to
            the digital copy unless you'd like to pay for another physical copy
            to be shipped.
          </p>
        ),
      },
      {
        question: "Do you offer currency conversion?",
        answer:
          "Currency conversion is not included with our certified translations. We do offer currency conversion on a case-by-case basis and can provide you with a quote for the service. You will have to supply the exchange rate, and we will note it on the Certificate of Translation Accuracy.",
      },
      {
        question: "Do you evaluate foreign credentials?",
        answer:
          "No, credential evaluation is a different discipline and is not performed by a translator. We can provide a certified translation of your academic documents, which you will then submit along with your source documents to a specialist to evaluate the credentials to find the equivalences in your target country.",
      },
      {
        question: "Can you fill out forms for me?",
        answer:
          "We typically do not fill out forms for you, but this is determined on a case-by-case basis. Contact us before placing your order with the specifics of your request and we will let you know if we are able to assist.",
      },
      {
        question: "Do I need to submit original documents to you?",
        answer:
          "No. An original copy of your document is not necessary. A scanned copy via email, fax, or photograph is sufficient.",
      },
      {
        question:
          "What's the difference between a certified and notarized translation?",
        answer:
          "A certified translation is a document translated by a professional translator and accompanied by a signed Certificate of Accuracy. A notarized translation bears a notary’s seal and is an additional service that involves adding the signature of a notary to your document. You can always contact us if you’re not sure what type of document you need.",
      },
      {
        question: 'What is a "sworn translator" and do you have any available?',
        answer:
          "A sworn translator is a translator who has been certified by the government of his or her residence and can directly stamp their translations as accurate and faithful to the original document. The system in the US and many other countries works differently and we combine our agency certification with a notary’s signature to achieve the equivalent standard.",
      },
    ],
    standardTranslations: [
      {
        question: "What is a standard translation?",
        answer:
          "A human translation of documents or text-based content delivered in an editable format for business or personal use. Perfect for legal documents, employee manuals, business communications, blog posts, product descriptions, and many other documents and types of content.",
      },
      {
        question: "What will you deliver to me?",
        answer:
          "Standard translations are delivered as an editable Microsoft Word document (.docx). If you need another format such as .pages, .txt, .rtf, etc. we can likely accommodate. Standard translations only include very basic formatting. If you have complex formatting or need the translation to be completed in the document you supply please contact us and include a detailed description of your needs.",
      },
      {
        question: "Do you offer expedited turnaround?",
        answer:
          "Expedited turnaround is available for an additional fee and will reduce turnaround time by approximately 50%. Expedited orders are flagged as high-priority, moved to the front of the queue, and extended hours are worked to ensure the quickest turnaround possible.",
      },
    ],
    abouteVerbary: [
      {
        question: "Can I read reviews or check references?",
        answer: `You can read thousands of reviews online directly from verified clients to hear first hand how we consistently live up to our promise of quick turnaround times and great quality.
    
    Be aware that this is the only place online to read real reviews directly from our clients. We are aware of multiple fraudulent sites with fake reviews setup to dissuade clients from using us and several other top translation service suppliers.`,
      },
      {
        question: "Is eVerbary an ATA member?",
        answer: (
          <p>
            We are a corporate member of the American Translators Association
            (ATA).
            <br />
            <br />
            There is no worldwide standard for individual translator
            certification. Our translators typically maintain credentials based
            on the country they live in, but it can vary per individual. If you
            have a specific requirement please contact us prior to ordering.
          </p>
        ),
      },
      {
        question: "Can I send or drop off my documents?",
        answer:
          "We do not accept physical documents either in person or via mail. We only accept digital files via WhatsApp or uploaded through this website's secure uploader for quotes and orders. These are the safest and most efficient ways to handle your documents.",
      },
      {
        question: "Do you offer phone support?",
        answer:
          "We exclusively offer email support to ensure accuracy and efficiency in supporting your translation needs. We found that phone support was too prone to miscommunication when dealing with the wide variety of documents and languages we support.",
      },
    ],
    otherQuestions: [
      {
        question: "What is the status of my order?",
        answer:
          "You can check the status of your order anytime by visiting your order status page. A link to your order status page can be found in the confirmation email and other order related communications.",
      },
      {
        question: "How do I modify or cancel my order?",
        answer: (
          <p>
            We will do everything possible to accommodate your modification
            request, but these will be handled on a case-by-case basis.
            <br />
            <br />
            Cancellation requests will also be handled on a case-by-case basis
            and any work completed cannot be canceled. If possible we will have
            the translator stop the project and we will issue a pro-rated refund
            for work not completed. Smaller orders are typically not able to be
            canceled once they have been accepted by a translator.
            <br />
            <br />
            Please contact us immediately with your modification or cancellation
            request.
          </p>
        ),
      },
      {
        question: "How do I request a revision?",
        answer:
          "You can request a revision directly from your order status page. We provide a link to your order status page in the order confirmation email and in most other communications.",
      },
    ],
  };

  const [activeIndex, setActiveIndex] = useState(null);

  const handleToggle = (index) => {
    setActiveIndex((prevIndex) => (prevIndex === index ? null : index));
  };

  return (
    <div className="container mx-auto flex lg:flex-row flex-col gap-10 my-10">
      <div className="lg:w-1/3 w-full space-y-4">
        <h1 className="text-7xl text-tertiary font-medium font-secondary">
          FAQs
        </h1>
        <p className="text-[#686F7B] text-base pr-12">
          In this section, we answer some frequent questions related to our
          services. If you have any further questions, please
          <span className="text-primary"> contact our support team.</span>
        </p>
      </div>
      <div className="lg:w-2/3 w-full ">
        <div className="flex w-full gap-2 py-2 overflow-x-auto lg:px-2">
          {questionsCatagories.map((item, index) => (
            <div
              key={index}
              className={`border px-4 py-2 text-center rounded-full text-base font-medium cursor-pointer whitespace-nowrap ${
                activeCategory === item.value
                  ? "bg-[#F46350] text-white border-[#F46350]"
                  : "bg-white border-tertiary text-tertiary"
              }`}
              onClick={() => {
                setActiveCategory(item.value);
                setActiveIndex(null);
              }}
            >
              {item.name}
            </div>
          ))}
        </div>

        <div className="flex flex-col gap-4 mt-8">
          {questions[activeCategory]?.map((item, index) => (
            <QuestionAns
              key={index}
              question={item.question}
              answer={item.answer}
              isOpen={activeIndex === index}
              onToggle={() => handleToggle(index)}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default FaqSection;
